export interface IAutoCompleteLabelValue {
  label: string;
  value: any;
  item?: any;
}

export const GenderList = [
  {
    label: "مرد",
    value: "false",
  },
  {
    label: "زن",
    value: "true",
  },
];

export enum UserType {
  Haghighi = "true",
  Hoghoghi = "false",
}

export const TypeUserList = [
  {
    label: "حقیقی",
    value: "true",
  },
  {
    label: "حقوقی",
    value: "false",
  },
];

export const CompanyTypeList = [
  {
    label: "مشارکتی",
    value: "true",
  },
  {
    label: "انفرادی",
    value: "false",
  },
];
